//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { venues_detail } from '@/apis/stadium'
import { area_list } from '@/apis/config'
export default {
    data() {
        return {
            id: 0,
            item: {},
            areaItem: {},
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        if (this.id > 0) {
            this.onPageLoad();
        }
    },
    methods: {
        async onPageLoad() {
            try {
                const res = await venues_detail(this.id);
                this.item = res.data;
                this.areaItem = await this.getArea(this.item.areaCode);
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getArea(code) {
            try {
                const res = await area_list();
                if (res.code == 0) {
                    let items = res.data;
                    if (items && items.length > 0) {
                        const fRes = items.filter(item => item.areaCode == code);
                        if (fRes.length > 0) {
                            return fRes[0];
                        }
                    }
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        toEdit() {
            this.$router.push(`/gymnasium/form/${this.id}`);
        }
    }
}
